// Never derive an executable payment amount from a browser FX estimate.
export function upiPaymentURI(id: string, address: string, amount: string, currency: string): string {
  if (typeof address === 'string' && address.startsWith('upi://')) {
    return address;
  }
  if (!/^[0-9a-f-]{36}$/i.test(id) || !/^[A-Za-z0-9._-]{2,128}@[A-Za-z0-9.-]{2,64}$/.test(address)
    || currency !== 'INR' || !/^(0|[1-9]\d{0,19})(\.\d{1,2})?$/.test(amount) || !/[1-9]/.test(amount)) {
    throw new Error('Verified INR deposit amount and receiving account are required for UPI checkout');
  }
  return `upi://pay?${new URLSearchParams({pa:address,am:amount,cu:'INR',tn:id,tr:id}).toString()}`;
}

